<template>
  <div v-if="!isCompleted">
    <div class="tw-absolute tw-top-2 tw-left-2">S.P. {{ spellingPoints }}</div>
    <div class="task-header">
      <div class="tw-mt-[50px]" v-if="sentenceValue">
        {{ sentenceValue[0] }}
        <span class="tw-underline">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        {{ sentenceValue[1] }}
      </div>
    </div>
    <TaskA v-if="task == 1" @success="task = 2" />
    <TaskB v-else-if="task == 2" @success="task = 3" />
    <TaskC v-else-if="task == 3" @success="task = 4" />
    <TaskD v-else-if="task == 4" @completed="nextWord" @tryagain="task = 1" />
    <div
      class="tw-absolute tw-w-full tw-text-center tw-bottom-[20px] tw-left-0"
    >
      <div class="tw-inline-block tw-mx-[20px]" v-if="sentence?.audio_file">
        <a href="" @click.prevent="playSentenceAudio" class="speaker tw-text-primary">
          Sentence
          <span class="tw-inline-block tw-ml-[5px]">
            <SpeakerSvg />
          </span>
        </a>
      </div>
      <div class="tw-inline-block tw-mx-[20px]">
        <a href="" @click.prevent="playWordAudio" class="speaker tw-text-primary">
          Word
          <span class="tw-inline-block tw-ml-[5px]">
            <SpeakerSvg />
          </span>
        </a>
      </div>
    </div>
    <div class="tw-absolute tw-bottom-[10px] tw-right-[10px]">
      {{ progress }}
    </div>
  </div>
</template>

<style scoped lang="postcss">
.speaker {
  @apply tw-flex tw-items-center;
}
.speaker svg {
  width: 40px;
  height: 40px;
  fill: #51abf5;
  stroke: #51abf5;
}

.speaker:hover svg {
  fill: #0089fa;
  stroke: #0089fa;
}

:deep(.act-dl-cl-1) {
  color: #ff0000;
}

:deep(.act-dl-cl-2) {
  color: #0000cc;
}

:deep(.act-dl-cl-3) {
  color: #018f01;
}

:deep(.act-dl-cl-4) {
  color: #c77400;
}

:deep(.act-dl-cl-5) {
  color: #ff0072;
}

:deep(.act-dl-cl-6) {
  color: #00cccc;
}

:deep(.act-dl-cl-7) {
  color: #7e0397;
}

:deep(.act-dl-border) {
  border-color: currentColor;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import {
  sfActivityWordCount,
  sfStopActivityAudio,
  sfPlayActivityAudio,
  sfActivityCurrentWordId,
  sfActivityCurrentWord,
  sfActivityCurrentSentence,
  sfActivityNextWord,
  sfActivityMode,
  sfACtivityPoints,
} from "@/state/sfActivityState";
import { SfWordElement } from "@/types/spellingTypes";

import TaskA from "@/components/games/sf-activity/activity-components/TaskA.vue";
import SpeakerSvg from "@/svg/SpeakerSvg.vue";
import TaskB from "../activity-components/TaskB.vue";
import TaskC from "../activity-components/TaskC.vue";
import TaskD from "../activity-components/TaskD.vue";
import { sfActivityCompleted } from "@/state/sfActivityState";

export default defineComponent({
  components: { TaskA, SpeakerSvg, TaskB, TaskC, TaskD },
  data() {
    return {
      task: 1,
    };
  },
  computed: {
    sentence(): SfWordElement | null {
      return sfActivityCurrentSentence.value;
    },
    sentenceValue(): string[] | null {
      if (!this.sentence) {
        return null;
      }
      return this.sentence.value.split("[[x]]");
    },
    progress(): string {
      return (
        sfActivityCurrentWordId.value + 1 + " / " + sfActivityWordCount.value
      );
    },
    spellingPoints(): number {
      return sfACtivityPoints.value;
    },
    isCompleted(): boolean {
      return sfActivityCompleted.value;
    },
  },
  mounted() {
    this.initWord();
  },
  methods: {
    initWord() {
      if (sfActivityMode.value == "test") {
        this.task = 4;
      } else {
        this.task = 1;
      }
    },
    playSentenceAudio() {
      if (!this.sentence) {
        return;
      }
      sfStopActivityAudio();
      sfPlayActivityAudio("sen_" + this.sentence.id);
    },
    playWordAudio() {
      if (!sfActivityCurrentWord.value) {
        return;
      }
      sfStopActivityAudio();
      sfPlayActivityAudio("w_" + sfActivityCurrentWord.value.id);
    },
    nextWord() {
      sfActivityNextWord();
      this.initWord();
    },
  },
});
</script>
